import { createContext, useContext } from "react";
import { cmsJson } from "@/lib/sacred-pages/cms-helpers";

const CmsPageContext = createContext({
  page: null,
  loading: true,
  slug: "",
});

export function CmsPageProvider({ value, children }) {
  return <CmsPageContext.Provider value={value}>{children}</CmsPageContext.Provider>;
}

export function useCmsPage() {
  return useContext(CmsPageContext);
}

/** Shorthand: merged labels object from CMS `labels` inline section */
export function useCmsLabels(fallback = {}) {
  const { page } = useCmsPage();
  return { ...fallback, ...cmsJson(page, "labels", {}) };
}
